module.exports = __webpack_public_path__ + "img/easy-southwest-chicken-soup.ab7f1187.jpg";